var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 11.535,
    viewBox: "0 0 12.5 11.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M3.911,3.692H9.079a1.1,1.1,0,0,1,1.028.7l1.718,4.069a1.145,1.145,0,0,1,.078.421v1.16a1.325,1.325,0,0,1-1.136,1.34H7.183l.541,2.449.018.18a.87.87,0,0,1-.25.61l-.6.6L3.1,11.406a1.156,1.156,0,0,1-.33-.814V4.822a1.133,1.133,0,0,1,1.142-1.13Z",
    transform: "translate(0.596 -3.692)",
    fill: "#5e5e5e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M25,3.692H23.077v6.731H25Z",
    transform: "translate(-23.077 -3.692)",
    fill: "#5e5e5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.778abd3cbcf69e7f806aa380c660fc3a.svg";
export { ForwardRef as ReactComponent };